// extracted by mini-css-extract-plugin
export default {"accordionSideMenu":"accordion-side-menu_accordionSideMenu__mjUnp","moreButton":"accordion-side-menu_moreButton__MtBdW"};